<template>
    <span>{{ minPoints }}</span>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    rates: {
        type: Array,
        required: true,
    },
});

const minPoints = computed(() => {
    let value = 1000;
    let points = [];
    let cash = [];
    let pointsCash = [];
    props.rates.forEach((rate) => {
        if (rate.rate_type === 'points') {
            points.push(rate.points);
        }
        if (rate.rate_type === 'points_cash') {
            cash.push(rate.rate);
            pointsCash.push(rate.points);
        }
    });

    if (points.length === 0 && cash.length === 0) {
        return '';
    }

    let cashSymbol = cash.length && !points.length ? '+$' : '';
    value = points.length ? points : pointsCash;

    let minCost = (Math.min(...value) / 1000).toFixed(1).replace('.0', '');

    return minCost + 'k' + cashSymbol;
});
</script>
